/**
 * Human labels for the unit codes a user picks from.
 *
 * The forms rendered the stored code straight into the option text, so a
 * salesperson choosing an area unit was shown `SQ_FT`. The code itself cannot
 * change -- it is the value the API stores, the rate engine matches on and
 * every existing job, rate card and claim line already carries -- so only the
 * text shown beside it is translated here, and the value attribute keeps the
 * code untouched.
 *
 * Units are not localised: `mob.closure.area.sqftValue` already reads
 * "{value} Sq Ft" in both the English and Hindi catalogues, so this matches
 * the spelling the rest of the product already shows.
 */

const UNIT_LABELS: Readonly<Record<string, string>> = {
  SQ_FT: 'Sq Ft',
  SQFT: 'Sq Ft',
  SQ_MT: 'Sq M',
  // The backend's migration alias of SQ_MT (m06 AreaUnit); older jobs carry it.
  SQ_METER: 'Sq M',
  PER_SQ_FT: 'Per Sq Ft',
  PER_SQFT: 'Per Sq Ft',
};

/** The text to show for a unit code; unknown codes are shown unchanged. */
export function unitLabel(code: string): string {
  return UNIT_LABELS[code] ?? code;
}
